
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class DataReportsVisibleSheetsEditor extends Serenity.CheckTreeEditor<Serenity.CheckTreeItem<any>, any> {

        private searchText: string;

        constructor(div: JQuery) {
            super(div);
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text) => {
                this.searchText = Select2.util.stripDiacritics(text || '').toUpperCase();
                this.view.setItems(this.view.getItems(), true);
            });
        }

        protected getButtons() {
            return [];
        }

        private _sheetNames: string[];

        public set sheetNames(value: string[]) {
            this._sheetNames = value || [];
            this.updateItems();
        }

        protected getTreeItems() {
            return (this._sheetNames || []).map(x => <Serenity.CheckTreeItem<any>>{
                id: x,
                text: x
            });
        }

        protected onViewFilter(item) {
            return super.onViewFilter(item) &&
                (Q.isEmptyOrNull(this.searchText) ||
                    Select2.util.stripDiacritics(item.text || '')
                        .toUpperCase().indexOf(this.searchText) >= 0);
        }
    }
}